import type { IconName } from '@hotjar/hotsauce';
import { Text } from '@hotjar/hotsauce';
import { Container, LeftContainer as TextContainer, StyledIcon } from './SmartPanelSpacedText';

const TEXT_COLOR = 'text_default';

export const SmartPanelSpacedTextWithBadge = ({
  text,
  icon,
  badge,
}: {
  text: string;
  icon?: IconName;
  badge: React.ReactElement | null;
}): JSX.Element => {
  return (
    <Container>
      <TextContainer>
        {icon !== undefined && <StyledIcon icon={icon} color={TEXT_COLOR} />}
        <Text as="span" textColor={TEXT_COLOR}>
          {text}
        </Text>
      </TextContainer>
      {badge}
    </Container>
  );
};
